module.exports = __webpack_public_path__ + "assets/img/lung_chart_en.738ddb54.png";